<template>
  <v-ons-page>

    <div class="header" style="text-align: center;">
      <img src="../../assets/lasmeru-logo-bold.png" width="200" height="200" style="margin-top: 50px; margin-bottom: 30px;">
    </div>

    <div style="text-align: center">
      <p>認証が完了しました。</p>
      <p>登録情報を保存中です...<span v-show="spinning"><v-ons-icon icon="fa-spinner"></v-ons-icon></span></p>
    </div>

  </v-ons-page>
</template>

<script>
// import firebase from 'firebase'
import common from '../../util/common'

export default {
  name: 'callback',
  mixins: [common],
  data () {
    return {
      spinning: false
    }
  },

  created () {
    this.getQueryParams()
  },

  mounted () {
  },

  computed: {
  },

  watch: {
  },

  methods: {
    getQueryParams () {
      let obj = {}
      this.spinning = true

      let provider = this.$route.query.provider
      if (provider === 'twitter') {
        let accessToken = this.$route.query.access_token
        let accessTokenSecret = this.$route.query.access_token_secret
        let profileId = this.$route.query.profile_id
        let profileIdStr = this.$route.query.profile_id_str
        let profileName = this.$route.query.profile_name
        let profileScreenName = this.$route.query.profile_screen_name

        obj = {
          provider: provider,
          profileId: profileId,
          profileIdStr: profileIdStr,
          profileName: profileName,
          profileScreenName: profileScreenName,
          accessToken: accessToken,
          accessTokenSecret: accessTokenSecret,
          version: 1,
          timeStamp: this.timestamp()
        }
      }

      // this.setTokens(provider, obj)
      window.localStorage.setItem('auth-info', JSON.stringify(obj))
      this.closePopup(provider)
    },

    closePopup (provider) {
      console.log('closePopup')
      let windowName = provider
      let popupOptions = {}

      if (provider === 'twitter') {
        popupOptions = { width: 495, height: 645 }
      }

      var popupPlayer = window.open('', windowName, popupOptions)
      popupPlayer.focus()
      popupPlayer.close()
      // facebook:
      //   name: 'facebook',
      //   popupOptions: { width: 580, height: 400 }
      // google:
      //   name: 'google',
      //   popupOptions: { width: 452, height: 633 }
      // github:
      //   name: 'github',
      //   popupOptions: { width: 1020, height: 618 }
      // instagram:
      //   name: 'instagram',
      //   popupOptions: { width: null, height: null }
      // twitter:
      //   name: 'twitter',
      //   popupOptions: { width: 495, height: 645 }
      // bitbucket:
      //   name: 'bitbucket',
      //   popupOptions: { width: 1020, height: 618 }
      // linkedin:
      //   name: 'linkedin',
      //   popupOptions: { width: 527, height: 582 }
      // live:
      //   name: 'live',
      //   oauthType: '2.0',
      //   popupOptions: { width: 500, height: 560 }
      // oauth1:
      //   name: null,
      //   oauthType: '1.0',
      //   popupOptions: null
      // oauth2:
      //   name: null,
      //   popupOptions: null,
    }
  }
}
</script>

<style scoped>
/* @import "../../../src/assets/css/miley.css"; */

</style>



// WEBPACK FOOTER //
// src/components/auth/callback.vue